(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ha-barnums"]) return;
  try {
    
(()=>{
function init(root){if(root.dataset.ready)return;root.dataset.ready='true';let busy=false;const base=window.Shopify?.routes?.root||'/';
root.querySelectorAll('.ha-add-form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();if(busy||!form.reportValidity())return;const button=form.querySelector('button'),status=form.querySelector('.ha-status'),id=Number(form.elements.id.value),quantity=Number(form.elements.quantity.value);if(!Number.isSafeInteger(id)||!Number.isSafeInteger(quantity)||quantity<1)return;busy=true;button.disabled=true;button.textContent=form.dataset.adding;
try{const drawer=document.querySelector('cart-notification')||document.querySelector('cart-drawer');if(drawer)drawer.setActiveElement(button);const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity}],...(drawer?{sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:location.pathname}:{})})});const result=await response.json();if(!response.ok)throw new Error(result.description||form.dataset.error);status.textContent=form.dataset.added;button.textContent=form.dataset.added;if(drawer&&result.sections){drawer.classList.remove('is-empty');try{drawer.renderContents(result)}catch{location.assign(base+'cart')}}else location.assign(base+'cart');
}catch(error){status.textContent=error.message;button.textContent=form.dataset.add}finally{busy=false;button.disabled=false}}));
root.querySelectorAll('a[href="#tarifs-barnums"]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();requestAnimationFrame(()=>{const table=root.querySelector('#tarifs-barnums');table.open=true;table.scrollIntoView({block:'start'});});}));
}document.querySelectorAll('#ha-barnums').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('#ha-barnums').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ha-food"]) return;
  try {
    
(()=>{
function init(root){if(root.dataset.ready)return;root.dataset.ready='true';let busy=false;const base=window.Shopify?.routes?.root||'/';
root.querySelectorAll('.ha-add-form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();if(busy||!form.reportValidity())return;const button=form.querySelector('button'),status=form.querySelector('.ha-status'),id=Number(form.elements.id.value),quantity=Number(form.elements.quantity.value);if(!Number.isSafeInteger(id)||!Number.isSafeInteger(quantity)||quantity<1)return;busy=true;button.disabled=true;button.textContent=form.dataset.adding;
try{const drawer=document.querySelector('cart-notification')||document.querySelector('cart-drawer');if(drawer)drawer.setActiveElement(button);const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity}],...(drawer?{sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:location.pathname}:{})})});const result=await response.json();if(!response.ok)throw new Error(result.description||form.dataset.error);status.textContent=form.dataset.added;button.textContent=form.dataset.added;if(drawer&&result.sections){drawer.classList.remove('is-empty');try{drawer.renderContents(result)}catch{location.assign(base+'cart')}}else location.assign(base+'cart');
}catch(error){status.textContent=error.message;button.textContent=form.dataset.add}finally{busy=false;button.disabled=false}}));
root.querySelectorAll('a[href="#tarifs-machines"]').forEach(a=>a.addEventListener('click',()=>root.querySelector('#tarifs-machines').open=true));
}document.querySelectorAll('#ha-food').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('#ha-food').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ha-furniture"]) return;
  try {
    
(()=>{
function init(root){if(root.dataset.ready)return;root.dataset.ready='true';let busy=false;const base=window.Shopify?.routes?.root||'/';
root.querySelectorAll('.ha-add-form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();if(busy||!form.reportValidity())return;const button=form.querySelector('button'),status=form.querySelector('.ha-status'),id=Number(form.elements.id.value),quantity=Number(form.elements.quantity.value);if(!Number.isSafeInteger(id)||!Number.isSafeInteger(quantity)||quantity<1)return;busy=true;button.disabled=true;button.textContent=form.dataset.adding;
try{const drawer=document.querySelector('cart-notification')||document.querySelector('cart-drawer');if(drawer)drawer.setActiveElement(button);const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity}],...(drawer?{sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:location.pathname}:{})})});const result=await response.json();if(!response.ok)throw new Error(result.description||form.dataset.error);status.textContent=form.dataset.added;button.textContent=form.dataset.added;if(drawer&&result.sections){drawer.classList.remove('is-empty');try{drawer.renderContents(result)}catch{location.assign(base+'cart')}}else location.assign(base+'cart');
}catch(error){status.textContent=error.message;button.textContent=form.dataset.add}finally{busy=false;button.disabled=false}}));
root.querySelectorAll('a[href="#tarifs-mobilier"]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();requestAnimationFrame(()=>{const table=root.querySelector('#tarifs-mobilier');table.open=true;table.scrollIntoView({block:'start'});});}));
}document.querySelectorAll('#ha-furniture').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('#ha-furniture').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ha-games"]) return;
  try {
    
(()=>{
function init(root){if(root.dataset.ready)return;root.dataset.ready='true';let busy=false;const base=window.Shopify?.routes?.root||'/';
root.querySelectorAll('.ha-add-form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();if(busy||!form.reportValidity())return;const button=form.querySelector('button'),status=form.querySelector('.ha-status'),id=Number(form.elements.id.value),quantity=Number(form.elements.quantity.value);if(!Number.isSafeInteger(id)||!Number.isSafeInteger(quantity)||quantity<1)return;busy=true;button.disabled=true;button.textContent=form.dataset.adding;
try{const drawer=document.querySelector('cart-notification')||document.querySelector('cart-drawer');if(drawer)drawer.setActiveElement(button);const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity}],...(drawer?{sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:location.pathname}:{})})});const result=await response.json();if(!response.ok)throw new Error(result.description||form.dataset.error);status.textContent=form.dataset.added;button.textContent=form.dataset.added;if(drawer&&result.sections){drawer.classList.remove('is-empty');try{drawer.renderContents(result)}catch{location.assign(base+'cart')}}else location.assign(base+'cart');
}catch(error){status.textContent=error.message;button.textContent=form.dataset.add}finally{busy=false;button.disabled=false}}));
root.querySelectorAll('a[href="#tarifs-jeux"]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();requestAnimationFrame(()=>{const table=root.querySelector('#tarifs-jeux');table.open=true;table.scrollIntoView({block:'start'});});}));
}document.querySelectorAll('#ha-games').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('#ha-games').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ha-inflatables"]) return;
  try {
    
(()=>{
function init(root){if(root.dataset.ready)return;root.dataset.ready='true';let busy=false;const base=window.Shopify?.routes?.root||'/';
root.querySelectorAll('.ha-add-form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();if(busy||!form.reportValidity())return;const button=form.querySelector('button'),status=form.querySelector('.ha-status'),id=Number(form.elements.id.value),quantity=Number(form.elements.quantity.value);if(!Number.isSafeInteger(id)||!Number.isSafeInteger(quantity)||quantity<1)return;busy=true;button.disabled=true;button.textContent=form.dataset.adding;
try{const drawer=document.querySelector('cart-notification')||document.querySelector('cart-drawer');if(drawer)drawer.setActiveElement(button);const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity}],...(drawer?{sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:location.pathname}:{})})});const result=await response.json();if(!response.ok)throw new Error(result.description||form.dataset.error);status.textContent=form.dataset.added;button.textContent=form.dataset.added;if(drawer&&result.sections){drawer.classList.remove('is-empty');try{drawer.renderContents(result)}catch{location.assign(base+'cart')}}else location.assign(base+'cart');
}catch(error){status.textContent=error.message;button.textContent=form.dataset.add}finally{busy=false;button.disabled=false}}));
root.querySelectorAll('a[href="#tarifs-gonflables"]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();requestAnimationFrame(()=>{const table=root.querySelector('#tarifs-gonflables');table.open=true;table.scrollIntoView({block:'start'});});}));
}document.querySelectorAll('#ha-inflatables').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('#ha-inflatables').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ha-photobooth"]) return;
  try {
    
(() => {
 const root=document.querySelector('#ha-pb');if(!root)return;
 const base=window.Shopify?.routes?.root||'/';let busy=false;
 const money=c=>(c/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'});
 async function api(path,data){const r=await fetch(base+path,{method:data?'POST':'GET',headers:{Accept:'application/json',...(data?{'Content-Type':'application/json'}:{})},...(data?{body:JSON.stringify(data)}:{})});const json=await r.json();if(!r.ok)throw new Error(json.description||'Impossible de mettre à jour le panier. Réessayez.');return json;}
 async function add(box,button){if(busy)return;const choice=box.querySelector('input[type=radio]:checked'),qty=box.querySelector('.ha-post-count'),status=box.querySelector('.ha-status');if(!choice||(qty&&!qty.reportValidity()))return;const id=Number(choice.dataset.variantId||choice.value),quantity=qty?Number(qty.value):1;if(!Number.isSafeInteger(id)||id<=0){status.textContent='Choisissez une formule disponible.';return;}busy=true;button.disabled=true;button.textContent='Ajout en cours…';try{
  if(qty?.max){const cart=await api('cart.js');if(cart.items.filter(x=>x.variant_id===id).reduce((n,x)=>n+x.quantity,0)+quantity>Number(qty.max))throw new Error('Maximum 4 lots de poteaux dorés dans votre panier.');}
  const drawer=document.querySelector('cart-notification')||document.querySelector('cart-drawer');const year=button.dataset.year==='2027'||choice.dataset.year==='2027';
  if(drawer)drawer.setActiveElement(button);
  const result=await api('cart/add.js',{items:[{id,quantity,...(year?{properties:{Disponibilité:'Disponible en 2027'}}:{})}],...(drawer?{sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:location.pathname}:{})});
  status.replaceChildren();const link=document.createElement('a');link.href=base+'cart';link.textContent='Voir mon panier →';status.append('Ajouté au panier. ',link);button.textContent='Ajouté au panier ✓';
  if(drawer&&result.sections){drawer.classList.remove('is-empty');try{drawer.renderContents(result);}catch(e){location.assign(base+'cart');}}else location.assign(base+'cart');
 }catch(e){status.textContent=e.message;button.textContent='Ajouter au panier';}finally{busy=false;button.disabled=false;}}
 root.querySelectorAll('.ha-add-form').forEach(form=>form.addEventListener('submit',e=>{e.preventDefault();add(form,form.querySelector('button'));}));
 root.querySelectorAll('.ha-preview-choice').forEach(button=>button.addEventListener('click',()=>add(button.closest('.ha-proposal'),button)));
 root.querySelectorAll('.ha-options input').forEach(input=>input.addEventListener('change',()=>{const box=input.closest('.ha-add-form,.ha-proposal');box.querySelector('.ha-status').textContent='';box.querySelector('button.ha-btn').textContent='Ajouter au panier';}));
 root.querySelectorAll('.ha-post-count').forEach(input=>input.addEventListener('input',()=>{const box=input.closest('.ha-proposal');box.querySelector('.ha-post-total strong').textContent=input.validity.valid&&input.value!==''?money(Number(input.value)*1400)+' TTC':'Saisissez une quantité valide';box.querySelector('.ha-status').textContent='';box.querySelector('button.ha-btn').textContent='Ajouter au panier';}));
 root.querySelectorAll('.ha-reveal').forEach(button=>button.addEventListener('click',()=>button.setAttribute('aria-pressed',button.getAttribute('aria-pressed')!=='true')));
 root.querySelectorAll('a[href="#tarifs-photobooth"]').forEach(link=>link.addEventListener('click',()=>{root.querySelector('#tarifs-photobooth').open=true;}));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ha-sound"]) return;
  try {
    
(()=>{
function init(root){if(root.dataset.ready)return;root.dataset.ready='true';let busy=false;const base=window.Shopify?.routes?.root||'/';
root.querySelectorAll('.ha-add-form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();if(busy||!form.reportValidity())return;const button=form.querySelector('button'),status=form.querySelector('.ha-status'),id=Number(form.elements.id.value),quantity=Number(form.elements.quantity.value);if(!Number.isSafeInteger(id)||!Number.isSafeInteger(quantity)||quantity<1)return;busy=true;button.disabled=true;button.textContent=form.dataset.adding;
try{const drawer=document.querySelector('cart-notification')||document.querySelector('cart-drawer');if(drawer)drawer.setActiveElement(button);const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity}],...(drawer?{sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:location.pathname}:{})})});const result=await response.json();if(!response.ok)throw new Error(result.description||form.dataset.error);status.textContent=form.dataset.added;button.textContent=form.dataset.added;if(drawer&&result.sections){drawer.classList.remove('is-empty');try{drawer.renderContents(result)}catch{location.assign(base+'cart')}}else location.assign(base+'cart');
}catch(error){status.textContent=error.message;button.textContent=form.dataset.add}finally{busy=false;button.disabled=false}}));
root.querySelectorAll('a[href="#tarifs-sono"]').forEach(a=>a.addEventListener('click',()=>root.querySelector('#tarifs-sono').open=true));
}document.querySelectorAll('#ha-sound').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('#ha-sound').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
 class LmLookBook extends HTMLElement {
  constructor() {
    super();

    this.injectVendorScripts();
    this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
      this.handleTooltip(elem);
    });
  }

  async injectVendorScripts() {
    if (!window.FloatingUICore) {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0');
      document.head.appendChild(script);
    }
    if (!window.FloatingUIDOM) {
      await new Promise((r) => setTimeout(r, 500));

      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1');
      document.head.appendChild(script);
    }
  }

  handleTooltip(elem) {
    const btn = elem.querySelector('button');
    const tooltip = elem.querySelector('.lm-tooltip');

    function update() {
      window.FloatingUIDOM.computePosition(btn, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(0),
          window.FloatingUIDOM.autoPlacement(),
        ],
      }).then(({ x, y }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    }

    function showTooltip() {
      tooltip.classList.add('show');
      update();
    }

    function hideTooltip() {
      tooltip.classList.remove('show');
      tooltip.classList.add('hiding');
      setTimeout(() => {
        tooltip.classList.remove('hiding');
      }, 200);
    }

    const events = [
      ['mouseenter', showTooltip],
      ['mouseleave', hideTooltip],
      ['focus', showTooltip],
      ['blur', hideTooltip],
    ];

    // Detect if the device is touch-capable
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

    if (isTouchDevice) {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (tooltip.classList.contains('show')) {
          hideTooltip();
        } else {
          showTooltip();
        }
      });

      // Hide the tooltip when clicking outside
      document.addEventListener('click', (e) => {
        if (!elem.contains(e.target)) {
          hideTooltip();
        }
      });
    } else {
      events.forEach(([event, listener]) => {
        btn.addEventListener(event, listener);
      });
    }
  }
}

customElements.define('lumin-lookbook', LmLookBook);


  } catch(e) { console.error(e); }
})();
})();
